<template lang="html">
  <v-dialog
    v-model="opened"
    :fullscreen="$vuetify.breakpoint.xsOnly"
    width="700"
    persistent
    @keydown.esc="$emit('update:opened', false)"
  >
    <v-card block flat>
      <v-card-title
        class="title pb-0 text-xs-left d-flex"
        style="flex-wrap: nowrap"
      >
        <div>Line Items for {{ document ? document.name : '' }}</div>
        <v-spacer />
        <div style="flex: 0 !important">
          <v-btn
            fab
            small
            class="error--text text-none my-0"
            flat
            @click="$emit('update:opened', false)"
          >
            <v-icon size="25">clear</v-icon>
          </v-btn>
        </div>
      </v-card-title>

      <v-card-text class="text-xs-left subheading">
        <v-layout
          column
          class="mt-2 mb-2"
          :key="i"
          v-for="(item, i) in scheduleItems"
        >
          <v-layout align-center class="">
            <v-flex xs5 class="pr-4">
              <v-combobox
                v-if="editing.includes(item.id)"
                v-model="item.category"
                :disabled="!editing.includes(item.id)"
                :items="defaultItems"
                class="default-input"
                hide-details
                solo
              />
              <div
                v-else
                class="subheading grey--text text--darken-3 text-xs-left pr-2"
              >
                {{ item.category }}
              </div>
            </v-flex>

            <v-flex xs5 class="pr-2">
              <v-textarea
                v-if="multipleLineItems.includes(item.category)"
                v-model="item.value"
                :disabled="!editing.includes(item.id)"
                class="default-input"
                hide-details
                solo
              />
              <v-text-field
                v-else
                v-model="item.value"
                :disabled="!editing.includes(item.id)"
                class="default-input"
                hide-details
                solo
              />
            </v-flex>

            <v-flex xs2 v-if="editing.includes(item.id)" class="text-xs-right">
              <v-btn color="primary" small @click="saveEdit(item)">
                Save
              </v-btn>
              <v-btn outline small @click="cancelEdit(item.id)"> Cancel </v-btn>
            </v-flex>

            <v-flex xs2 v-else class="text-xs-right">
              <v-btn
                flat
                icon
                color="primary"
                class="ma-1"
                @click="edit(item.id)"
              >
                <v-icon>edit</v-icon>
              </v-btn>
              <v-btn
                flat
                icon
                color="error"
                class="ma-1"
                @click="deleteItem(item.id)"
                v-if="item.removable !== false"
                ><v-icon>delete</v-icon></v-btn
              >
            </v-flex>
          </v-layout>
        </v-layout>

        <v-layout column class="mt-2 mb-2" v-if="addingNewItem">
          <v-layout align-center class="">
            <v-flex xs5 class="pr-4">
              <v-combobox
                v-model="newItem.category"
                class="default-input"
                placeholder="Item name"
                :items="defaultItems"
                hide-details
                solo
              />
            </v-flex>

            <v-flex xs5 class="pr-4">
              <v-textarea
                v-if="multipleLineItems.includes(newItem.category)"
                v-model="newItem.value"
                class="default-input"
                placeholder="Value"
                hide-details
                solo
              />
              <v-text-field
                v-else
                v-model="newItem.value"
                class="default-input"
                placeholder="Value"
                hide-details
                solo
              />
            </v-flex>

            <v-flex xs2>
              <v-btn color="primary" small @click="saveNew()"> Save </v-btn>
              <v-btn outline small @click="cancelNew()"> Cancel </v-btn>
            </v-flex>
          </v-layout>
        </v-layout>

        <v-layout column class="mt-4 mb-4" v-else>
          <v-btn
            @click="addingNewItem = true"
            flat
            color="primary"
            class="text-capitalize"
          >
            <v-icon>add</v-icon> Add item
          </v-btn>
        </v-layout>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import API from '@/api';
import { customSections } from '@/constants/variables';

export default {
  name: 'PriorYearScheduleLineItems',

  props: {
    opened: {
      type: Boolean,
    },

    document: {
      type: Object,
    },

    companyId: {
      type: Number,
    },
  },

  data() {
    return {
      scheduleItems: [],
      defaultItems: [],
      multipleLineItems: ['Other (please include category & amount)'],

      editing: [],

      addingNewItem: false,
      newItem: {
        category: '',
        value: '',
      },
    };
  },

  methods: {
    edit(lineItemId) {
      this.editing.push(lineItemId);
    },

    cancelEdit(lineItemId) {
      this.editing = this.editing.filter(id => lineItemId !== id);
    },

    async saveEdit(item) {
      if (this.companyId) {
        await API.priorYearItem.updatePriorYearScheduleLineItem({
          companyId: this.companyId,
          lineItemId: item.id,
          category: item.category,
          value: item.value,
        });
      } else {
        await API.priorYearItem.updatePriorYearScheduleLineItemByItemId({
          lineItemId: item.id,
          category: item.category,
          value: item.value,
        });
      }

      await this.getAllItems();
      this.cancelEdit(item.id);
    },

    async deleteItem(lineItemId) {
      if (this.companyId) {
        await API.priorYearItem.deletePriorYearScheduleLineItem({
          companyId: this.companyId,
          lineItemId: lineItemId,
        });
      } else {
        await API.priorYearItem.deletePriorYearScheduleLineItemByItemId({
          lineItemId: lineItemId,
        });
      }

      await this.getAllItems();
    },

    cancelNew() {
      this.addingNewItem = false;
      this.newItem = {
        category: '',
        value: '',
      };
    },

    async saveNew() {
      if (this.companyId) {
        await API.priorYearItem.addPriorYearScheduleLineItem({
          companyId: this.companyId,
          priorYearItemId: this.document.id,
          category: this.newItem.category,
          value: this.newItem.value,
        });
      } else {
        await API.priorYearItem.addPriorYearScheduleLineItemWithoutCompany({
          priorYearItemId: this.document.id,
          category: this.newItem.category,
          value: this.newItem.value,
        });
      }

      await this.getAllItems();

      this.addingNewItem = false;
      this.newItem = {
        category: '',
        value: '',
      };
    },

    async getAllItems() {
      let response = null;
      if (this.companyId) {
        response = await API.priorYearItem.getPriorYearScheduleLineItems({
          companyId: this.companyId,
          priorYearItemId: this.document.id,
        });
      } else {
        response = await API.priorYearItem.getPriorYearScheduleLineItemsByPriorYearId(
          {
            priorYearItemId: this.document.id,
          },
        );
      }
      this.scheduleItems = response.data;
    },

    async getDefaultItems() {
      this.defaultItems = customSections
        .filter(section => {
          return this.document.name.includes(section.form);
        })
        .flatMap(section => {
          return section.sections.flatMap(subSection => {
            return subSection.fields;
          });
        });
    },
  },

  watch: {
    opened: {
      async handler(value) {
        if (value) {
          await this.getAllItems();
          await this.getDefaultItems();
        }
      },
    },
  },
};
</script>

<style lang="postcss" scoped></style>
